export default {
    currentDate() {
        const current = new Date();
        const day = current.getDate() < 10 ? '0'+current.getDate() :current.getDate()
        const formatted_date = current.toLocaleString('default', { month: 'short' })+' '+day +' '+current.getFullYear();
        return formatted_date; 
    },
    currentYear() {
        const current = new Date();
        return current.getFullYear();
    },
    formatDate(date){
        const current = new Date(date);
        const day = current.getDate() < 10 ? '0'+current.getDate() :current.getDate()
        return day+' '+current.toLocaleString('default', { month: 'short' })+' '+current.getFullYear()  
    },
    formatDateYear(date){
        const current = new Date(date);
        const day = current.getDate() < 10 ? '0'+current.getDate() :current.getDate()
        return day+' '+current.toLocaleString('default', { month: 'short' })+' '+current.getFullYear()%100  
    },
    formatDateTime(date){
        const current = new Date(date);
        const day = current.getDate() < 10 ? '0'+current.getDate() :current.getDate()
        const formatted_date = day+' '+current.toLocaleString('default', { month: 'short' })+' '+current.getFullYear();
        var hours = current.getHours();
        var minutes = current.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+ minutes : minutes;

        const formatted_time = hours == '12' && minutes =='00' && ampm =='AM' ?'-':hours + ':'+ minutes + ' '+ampm;

        return  formatted_date+' '+formatted_time; 
    },
    formatDateMilitary(date){
        const current = new Date(date);
        const day = current.getDate() < 10 ? '0'+current.getDate() :current.getDate()
        const formatted_date = day+' '+current.toLocaleString('default', { month: 'short' })+' '+current.getFullYear();
        var hours = current.getHours();
        var minutes = current.getMinutes();
        const formatted_time = hours + ':'+ minutes;

        return  formatted_date+' '+formatted_time; 
    },
    formatTime(date){
        const current = new Date(date);
        var hours = current.getHours();
        var minutes = current.getMinutes();
        var seconds = current.getSeconds();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+ minutes : minutes;
        seconds = seconds <10 ? '0' + seconds : seconds;
        

        const formatted_time = hours == '12' && minutes =='00' && ampm =='AM' ?'-':hours + ':'+ minutes + ':'+ seconds+' '+ampm;

        return  formatted_time; 
    },
    
    formatDuration(time){
        time =  time!==''? time : time = '00:00:00'
        time = time.toLocaleString().split(':')

        const formatted_duration = time[0] + 'h ' + time[1] + 'm ' + time[2] + 's'
        return formatted_duration
    },

    // hasPermission(action, profile){
    //     let permission = false
    //     if(profile && profile.permissions && profile.permissions.length!== 0 ){
    //         permission = profile.permissions.findIndex(d => d.code == action ) !== -1
    //     }
    //     return permission    
    // },
    hasPermission(action, profile, isGroupPermission){
        let permission = false
        if(profile && Array.isArray(action) && profile.permissions && profile.permissions.length!== 0 ){
            if (isGroupPermission) {
                permission = profile.permissions.some(permission => {
                    return action.some(action => permission.code.includes(action));
                })               
            } else {
                permission = profile.permissions.some(permission => {
                    return action.some(action => permission.code === action);
                });
            }
        } else if(profile && profile.permissions && profile.permissions.length!==0){
            permission = profile.permissions.findIndex(d => d.code == action ) !== -1
        }
        return permission    
    },
    // hasRole(action, profile){
    //     let role = false
    //     if (profile && profile.roles && profile.roles.length!== 0) {
    //         role = profile.roles.findIndex(d => d.name === action) !== -1
    //     }
    //     return role
    // }
    hasRole(action, profile){
        let role = false
        if (profile && Array.isArray(action) && profile.roles && profile.roles.length!== 0) {
            role = profile.roles.some(profile => {
                return action.some(action => profile.name === action);
            });
        } else if(profile && profile.roles && profile.roles.length!== 0) {
            role = profile.roles.findIndex(d => d.name === action) !== -1
        }
        return role
    },
}
